import Menu from 'classes/Menu/Search/Menu';
import MenuList from 'classes/Menu/Search/MenuList';
import SearchResultListRow from 'components/desktop/_general/AddMenuOrRecipe/MenusList/SearchResultListRow';

interface IProps {
	SourceOfAddingType: 'menu' | 'menuPlan' | 'menuCopy';
	SourceOfAddingId: string | null;
	SourceOfAddingRow: number;
	SourceOfAddingCol: number;
	finalizeAdding: () => void;
	menuList: MenuList;
}

const SearchResultListComponent = (props: IProps) => {
	return (
		<div className="d-flex flex-column" style={{ gap: '20px' }}>
			{props.menuList.all.map((e: Menu, i: number) => {
				return (
					<div key={i}>
						<SearchResultListRow
							SourceOfAddingCol={props.SourceOfAddingCol}
							SourceOfAddingId={props.SourceOfAddingId}
							SourceOfAddingRow={props.SourceOfAddingRow}
							SourceOfAddingType={props.SourceOfAddingType}
							finalizeAdding={props.finalizeAdding}
							menu={e}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default SearchResultListComponent;
